import api from '../../utils/api';

export type VendorContactQueryStatus = 'OPEN' | 'IN_PROGRESS' | 'REPLIED' | 'CLOSED';

export interface VendorContactQueryVendorSnapshot {
  generatedId: string | null;
  email: string | null;
  phoneNumber: string | null;
  vendorRole: number;
  vendorRoleName: string;
}

export interface VendorContactQueryRow {
  queryId: string;
  vendorId: string;
  serviceType: string;
  querySubject: string;
  queryDescription: string;
  status: VendorContactQueryStatus;
  maReply: string | null;
  maRepliedAt: string | null;
  maRepliedBy: string | null;
  maRepliedByName: string | null;
  priority: 'NORMAL' | 'HIGH';
  vendorSnapshot: VendorContactQueryVendorSnapshot | null;
  closedAt: string | null;
  isActive: boolean;
  createdAt: string | null;
  updatedAt: string | null;
}

interface VendorContactQueriesResponse {
  success: boolean;
  data: VendorContactQueryRow[];
  pagination: {
    limit: number;
    offset: number;
  };
}

export async function fetchVendorContactQueries(params?: {
  status?: VendorContactQueryStatus;
  serviceType?: string;
  vendorId?: string;
  limit?: number;
  offset?: number;
}): Promise<VendorContactQueriesResponse> {
  const response = await api.get<VendorContactQueriesResponse>('/master-admin/vendor-contact-queries', {
    params,
  });
  return response.data;
}

export async function fetchVendorContactQueryById(
  queryId: string
): Promise<{ success: boolean; data: VendorContactQueryRow }> {
  const response = await api.get<{ success: boolean; data: VendorContactQueryRow }>(
    `/master-admin/vendor-contact-queries/${encodeURIComponent(queryId)}`
  );
  return response.data;
}

export async function replyVendorContactQuery(
  queryId: string,
  payload: { maReply: string; status?: VendorContactQueryStatus }
): Promise<{ success: boolean; message: string; data: VendorContactQueryRow }> {
  const response = await api.patch(
    `/master-admin/vendor-contact-queries/${encodeURIComponent(queryId)}/reply`,
    payload
  );
  return response.data;
}

export async function updateVendorContactQueryStatus(
  queryId: string,
  status: VendorContactQueryStatus
): Promise<{ success: boolean; message: string; data: VendorContactQueryRow }> {
  const response = await api.patch(
    `/master-admin/vendor-contact-queries/${encodeURIComponent(queryId)}/status`,
    { status }
  );
  return response.data;
}
